// removed by extract-text-webpack-plugin
module.exports = {"title":"_2QYlO","content":"TrPc6"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Wallet/Wallet.scss
// module id = 214
// module chunks = 0 1